import { useTelemetryContext } from './TelemetryProvider';
import type { TelemetryService } from './telemetryService';

const noOp: TelemetryService = {
  trackEvent(): void {},
  trackPageView(): void {},
  trackException(): void {},
  flush(): void {},
};

export function useTelemetry(): TelemetryService {
  const service = useTelemetryContext();
  return service ?? noOp;
}
